import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'pg-form, grit-form',
  templateUrl: './pg-form.component.html',
  styleUrls: ['./pg-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PgFormComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
